import axios from 'axios'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import config from '@/config'
import router from '@/router/index'

// create an axios instance
const service = axios.create({
  baseURL: config.ApiYJ,
  timeout: 60000, // request timeout
  responseType: 'blob'
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    // Do something with request error
    Promise.reject(error)
  }
)

// respone interceptor
service.interceptors.response.use(
  (response) => response,
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  //  const res = response.data;
  //     if (res.code !== 20000) {
  //       Message({
  //         message: res.message,
  //         type: 'error',
  //         duration: 5 * 1000
  //       });
  //       // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //         MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //           confirmButtonText: '重新登录',
  //           cancelButtonText: '取消',
  //           type: 'warning'
  //         }).then(() => {
  //           store.dispatch('FedLogOut').then(() => {
  //             location.reload();// 为了重新实例化vue-router对象 避免bug
  //           });
  //         })
  //       }
  //       return Promise.reject('error');
  //     } else {
  //       return response.data;
  //     }
  (error) => {
    if (error.response.status !== 401) {
      const res = error.response.data
      let message = error.message
      if (res.responseStatus && res.responseStatus.message) {
        message = res.responseStatus.message
      }
      Message({
        message: message,
        type: 'error',
        showClose: true,
        duration: 5 * 1000
      })
    }

    if (error.response.status === 401) {
      // Message({
      //   message: '登陆凭据已失效，请重新登录',
      //   type: 'error',
      //   showClose: true,
      //   duration: 5 * 1000
      // })

      router.push({ path: '/login' })
    }
    return Promise.reject(error)
  }
)

export default service
